import React, { useState } from "react";
// import './SharingComponent.css';
import {
    IoCloseSharp,
    IoLinkOutline,
    IoMailOutline,
    IoSettingsOutline,
} from "react-icons/io5";
import { toAbsoluteUrl } from "../../../_helpers";
import DiamondTypeTag from "../DiamondTypeTag";
import CertificateLink from "../../CertificateLink";
import { PiFileTxt, PiNotePencilLight } from "react-icons/pi";
import "react-quill/dist/quill.snow.css";
import RichTextModal from "./RichTextModal";
import axios from "axios";
import { NODE_API_URL } from "../../../../env_config";
import Cookies from "js-cookie";
import { FaWhatsapp } from "react-icons/fa";
import "react-phone-input-2/lib/style.css";
import moment from "moment";
import ShareDetailCardSkeleton from "./ShareDetailCardSkeleton";
import { Alert } from "react-bootstrap";
import { IoMdInformationCircle } from "react-icons/io";

const SharingComponent = ({
    data,
    close,
    setOpenShareSetting,
    setNotes,
    setPhone,
    notes,
    finalPayload,
    userinfo,
    selectedValue,
    openShareSetting,
    certificateEnabled,
    startDate,
    password,
    loader,
    metaData
}) => {
    const [focused, setFocused] = useState(false);
    const [openEditor, setOpenEditor] = useState(false);
    const [editorData, setEditorData] = useState("");
    const [contactInput, setContactInput] = useState("");
    const [contactType,] = useState(null);
    const [contactError, setContactError] = useState("");
    const [editorValue, setEditorValue] = useState("");
    const [successMsg, setSuccessMsg] = useState("");

    const showSuccess = (msg) => {
        setSuccessMsg(msg);

        setTimeout(() => {
            setSuccessMsg("");
        }, 5000);
    };

    const isValidEmail = (email) => {
        const regex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const generateDiamondText = (data) => {
        return (
            `
        <p><strong>${data?.diamondType  === "N" || data?.diamondType === "F" ? "Natural" : "Lab Grown"}</strong> Diamond Details </p>
        <p>Stone ID: <strong>${data?.stockID || "-"}</strong></p>
        <p>Shape: <strong>${data?.shape || "-"}</strong></p>
        <p>Carat: <strong>${data?.carat ? `${data.carat.toFixed(2)}ct` : "-"}</strong></p>
        <p>Clarity: <strong>${data?.clarity || "-"}</strong></p>
        <p>Color: <strong>${data?.color ==="fancy" ? `${data?.fancy_intensity} ${data?.fancy_overtone} ${data?.fancy_color}` : data?.color || ""}</strong></p>
        <p>Cut: <strong>${data?.cut || "-"}</strong></p>
        <p>Pol: <strong>${data?.polish || "-"}</strong></p>
        <p>Symm: <strong>${data?.symmetry || "-"}</strong></p>
        <p>Fluor: <strong>${data?.fluorescence || ""}</strong></p>
        <p>Shade: <strong>${data?.shade || "-"}</strong></p>
        <p>Milky: <strong>${data?.milky || "-"}</strong></p>
        <p>Eye Clean: <strong>${data?.eyeClean || "-"}</strong></p>
        <p>Lab: <strong>${data?.lab || "-"}</strong></p>
        ${data?.showsharecertificate ? `<p>Certificate No.: <strong>${data?.certificate || "-"}</strong></p>` : "" }
        <p>Meas: <strong>${
            data?.length && data?.width && data?.height
                ? `${data.length}${data?.shape?.toLowerCase() === "round" ? "*" : "-"}${data.width}*${data.height}`
                : "-"
            }</strong></p>
        ${data?.tablePercent ? `<p>Table: <strong>${data?.tablePercent || "-"}</strong></p>` : ""}
        ${data?.depthPercent ? `<p>Depth: <strong>${data?.depthPercent || "-"}</strong></p>` : "" }
        ${(data?.ratio || data?.ratio !== "-") ? `<p>Ratio: <strong>${data?.ratio || "-"}</strong></p>` : ""}
        ${data?.origin && data?.origin !== 'Other' && data?.origin !== 'NONE' && data?.origin !== 'NON'  ? `<p>Origin: <strong>${data?.origin || "-"}</strong></p>` : ""}
        ${data?.brand && data?.brand !== 'Other'? `<p>Brand: <strong>${data?.brand || "-"}</strong></p>` : ""}
        ${data?.treatment && data?.treatment !== 'NONE' && data?.treatment !== 'NON' ? `<p>Treatment: <strong>${data?.treatment || "-"}</strong></p>` : ""}
        ${data?.image ? `<p>Image: <a href="${data?.image}" target="_blank" rel="noreferrer" >${data?.image || "-"}</a></p>` : "" }
        ${data?.heart ? `<p>Heart: <a href="${data?.heart}" target="_blank" rel="noreferrer" >${data?.heart || "-"}</a></p>` : "" }
        ${data?.arrow ? `<p>Arrow: <a href="${data?.arrow}" target="_blank" rel="noreferrer" >${data?.arrow || "-"}</a></p>` : "" }
        ${data?.asset ? `<p>Asset: <a href="${data?.asset}" target="_blank" rel="noreferrer" >${data?.asset || "-"}</a></p>` : "" }
        ${data?.video ? `<p>Video: <a href="${data?.video}" target="_blank" rel="noreferrer" >${data?.video || "-"}</a></p>` : "" }
        ${data?.showsharecertificate ? `<p>Certificate : <a href="${data?.certificate_link}" target="_blank" rel="noreferrer" >${data?.certificate_link || "-"}</a></p>` : "" }
        `.trim());
    };



    const htmlToWhatsapp = (html) => {
    return html
        .replace(/\n/g, "") 
        .replace(/\s+/g, " ") 
        .replace(/<strong>(.*?)<\/strong>/gi, "*$1*")
        .replace(/<b>(.*?)<\/b>/gi, "*$1*")
        .replace(/<em>(.*?)<\/em>/gi, "_$1_")
        .replace(/<i>(.*?)<\/i>/gi, "_$1_")
        .replace(/<\/p>/gi, "\n\n")
        .replace(/<p[^>]*>/gi, "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<a[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/gi, "$2: $1")
        .replace(/<[^>]+>/g, "")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    };

    const handleEmailSend = async () => {
        if (!contactInput) {
            setContactError("Required field");
            return;
        }

        if (!isValidEmail(contactInput)) {
            setContactError("Invalid email address");
            return;
        }

        try {
            const res = await axios.post(
            `${NODE_API_URL}/INTL/share-product`,
            {
                ...finalPayload,
                share_type: "email",
                share_through: "email",
                email: contactInput,
            },
            {
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
            }
            );

            showSuccess("Email sent successfully");
            setContactInput("");
            return; 
        } catch (e) {
            setContactError("Failed to send email");
            return; 
        }

    };

const handleWhatsappLinkSend = async () => {

     const result = await axios.post(
        `${NODE_API_URL}/INTL/share-product`,
        {
            ...finalPayload,
            share_type: "link",
            share_through: "whatsapp",
        },
        {
            headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        }
    );

    if (result?.data?.success){
           let link = result?.data?.share_domain
        //    `https://share.dia360.cloud/share/${result?.data?.share_token}?title=${encodeURIComponent(metaData?.title)}&shape=${encodeURIComponent(metaData?.shape)}`
           let text = `
<p>Hi,</p>
<p><strong>${userinfo?.cname}</strong> is sharing a link for 
 <strong>${data?.diamondType === "N" || data?.diamondType === "F" ? "Natural" : "Lab Grown"}</strong> Diamond -
<strong>${data?.shape} ${data?.carat ? `${data?.carat.toFixed(2)}ct` : ""} 
 ${data?.color === "fancy"
? `${data?.fancy_intensity} ${data?.fancy_overtone} ${data?.fancy_color}`
: data?.color || ""} ${data?.clarity}</strong></p>
${notes ?  `<p>${notes}</p>` : ''}
<p>Link: ${link}</p>
            `;
            
            const whatsappText = htmlToWhatsapp(text);
            window.open(
                `https://wa.me/?text=${encodeURIComponent(whatsappText)}`
            );
            showSuccess("Link shared on whatsApp successfully");
        }
    };


    function numberWithCommas(x) {
        if (x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return "0.00";
        }
    }

    const handleWhatsAppShare = async () => {
        await axios.post(
            `${NODE_API_URL}/INTL/share-product`,
            {
                ...finalPayload,
                share_type: "whatsapp",
                share_through: "whatsapp",
            },
            {
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
            }
        );
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = editorData; 

        const whatsappText = htmlToWhatsapp(editorValue);
        const url = `https://wa.me/?text=${encodeURIComponent(whatsappText)}`;

        window.open(url, "_blank");
        showSuccess("Shared via WhatsApp");
    };

    const handleCopy = async () => {

        try {
            const res =  await axios.post(
            `${NODE_API_URL}/INTL/share-product`,
            {
                ...finalPayload,
                share_type: "link",
                share_through: "link",
                // phone: formattedPhone,
            },
            {
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
            }
        );

        if (res?.data?.success){
            let link = res?.data?.share_domain
            // `https://share.dia360.cloud/share/${res?.data?.share_token}?title=${metaData?.title}&shape=${metaData?.shape}`
            navigator.clipboard.writeText(link);
            showSuccess("Link copied to clipboard!");
        }

        } catch {

        }
        // alert("Link copied to clipboard!");
    };
    return (
        <>
            <div className="d-flex justify-content-between mb-3">
                <span className=" font-size-h5 font-weight-bold">Share</span>
                <div>
                    <button
                        className="btn btn-sm btn-clear btn-hover-bg-light px-1 py-1"
                        onClick={() => setOpenShareSetting(true)}
                    >
                        <IoSettingsOutline className=" font-size-h4 text-primary" />
                    </button>
                    <button
                        className="btn btn-sm btn-clear btn-hover-bg-light px-1 py-1"
                        onClick={close}
                    >
                        <IoCloseSharp className=" font-size-h4 text-muted" />
                    </button>
                </div>
            </div>
            <div className="row">
                {(!openShareSetting &&
                    (!certificateEnabled || selectedValue === 'mark_up' || selectedValue === 'no_price')) && (
                        <div className="col-12">
                            <Alert variant={"primary"} className="d-flex align-items-center">
                                <IoMdInformationCircle className="text-primary font-size-h6 mr-1" />
                                <div className="text-dark font-weight-light">
                                    {!certificateEnabled && selectedValue === 'mark_up' ? (
                                        "Certificate is disabled and markup price is applied."
                                        ) : !certificateEnabled && selectedValue === 'no_price' ? (
                                            "Certificate is disabled and price will not be displayed."
                                        ) : selectedValue === 'no_price' ? (
                                        " Price will not be displayed."
                                        ) : selectedValue === 'mark_up' ? (
                                            "Markup price will be shown."
                                        ) : !certificateEnabled ? (
                                            "Certificate is disabled."
                                        ) : null}
                                </div>
                            </Alert>
                        </div>
                )}
                {loader ? <div className="col-12"><ShareDetailCardSkeleton /></div> :
                    <>
                        <div className="col-12 d-flex mb-4">
                            <div>
                                {data?.image ? (
                                    <img
                                        className="img-fluid"
                                        alt={data?.shape}
                                        src={data?.image}
                                        width="90px"
                                        onError={(e) => {
                                            e.currentTarget.src = toAbsoluteUrl(
                                                `/media/shape/${
                                                    data?.shape
                                                        ? data?.shape.toLowerCase()
                                                        : ""
                                                }-no.png`,
                                            );
                                        }}
                                    />
                                ) : (
                                    <img
                                        className="img-fluid"
                                        alt={data?.shape}
                                        src={toAbsoluteUrl(
                                            `/media/shape/${
                                                data?.shape
                                                    ? data?.shape.toLowerCase()
                                                    : ""
                                            }-no.png`,
                                        )}
                                        onError={(e) => {
                                            e.currentTarget.src = toAbsoluteUrl(
                                                `/media/shape/noimage.jpg`,
                                            );
                                        }}
                                        width="90px"
                                        style={{ backgroundColor: "#f4f4f4" }}
                                    />
                                )}
                            </div>
                            <div className="ml-4">
                                <div
                                    className={`mb-1 ${
                                        data?.diamondType === "N" ? "natTab" : "labTab"
                                    }`}
                                >
                                    <DiamondTypeTag
                                        diamondTypeTagColor={data?.diamondTypeTagColor}
                                        diamondTypeTag={data?.diamondTypeTag}
                                    />
                                    <span className={`text-primary small`}>
                                        {data?.diamondType === "N" ||
                                        data?.diamondType === "W"
                                            ? "N"
                                            : "L"}
                                        -{data?.stockID}
                                    </span>
                                    {data?.showsharecertificate && (
                                        <CertificateLink
                                            Certificate_link={data?.certificate_link}
                                            lab={data?.lab}
                                            certificate={data?.certificate}
                                            className={`mx-2 small`}
                                        />
                                    )}
                                </div>
                                <span className="text-dark font-weight-bold d-block">
                                    {data?.shape} {data?.carat ? `${data?.carat.toFixed(2)}ct` : null} {data?.color}{" "}
                                    {data?.clarity} {data?.cut} {data?.polish}{" "}
                                    {data?.symmetry} {data?.fluorescence}
                                </span>
                                {data?.showshareprice && (
                                    <div className="mt-3">
                                        <div className="small text-black-50">
                                            {data?.ourPriceShareExchangeSymbol}/CT{" "}
                                            {numberWithCommas(
                                                data?.ourRateShareExchange,
                                            )}
                                        </div>
                                        <div className="font-weight-bold font-size-h5">
                                            {data?.ourPriceShareExchangeSymbol}
                                            {numberWithCommas(
                                                data?.ourPriceShareExchange,
                                            )}
                                            {selectedValue === 'mark_up' && 
                                                <IoMdInformationCircle className="text-primary font-size-h6 ml-2 mb-1" />
                                            }
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                }
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <span className="text-capitalize">Share on Email</span>
                </div>
                   <div className="col-12">
                        <div className="input-group mb-2">
                            <div className="input-group-prepend">
                                <span className="input-group-text bg-white border-right-0 pl-3 pr-0">
                                {/* <BiUser className="text-muted" size={18} /> */}
                                        {contactType === "phone" ? (
                                            <FaWhatsapp className="text-success" size={18} />
                                        ) : (
                                            <IoMailOutline className="text-muted" size={18} />
                                        )}
                                </span>
                            </div>
                            <input
                                type="text"
                                value={contactInput}
                                onChange={(e) => {
                                    setContactInput(e.target.value);
                                    setContactError("");
                                }}
                                className="form-control border-left-0"
                                placeholder="Enter Email"
                            />
                        </div>
                        {contactError && (
                            <div className="text-danger text-left small mb-3">
                                {contactError}
                            </div>
                        )}
                   </div>
                <div className="col-12 text-center">
                    <div className={`onedrive-box ${focused ? "focused" : ""}`}>
                        <PiNotePencilLight
                            className="message-icon text-muted"
                            size={18}
                        />

                        <textarea
                            className="message-textarea"
                            placeholder="Add a message"
                            rows="3"
                            onChange={(e) => setNotes(e.target.value)}
                            onFocus={() => setFocused(true)}
                            onBlur={() => setFocused(false)}
                        />
                    </div>
                </div>
                <div className="col-12 mt-5 d-flex justify-content-between">
                    <div>
                        <button
                            className="btn btn-outline-secondary bg-primary-o-20 text-primary border-primary btn-sm mr-2"
                            onClick={() => {
                                setEditorData(generateDiamondText(data));
                                setContactInput('');
                                setOpenEditor(true);
                            }}
                        >
                            <PiFileTxt className="mr-2 font-size-h5" />
                            Text
                        </button>
                        <button
                            className="btn btn-outline-secondary bg-primary-o-20 text-primary border-primary btn-sm mr-2"
                            onClick={handleWhatsappLinkSend}
                        >
                             <FaWhatsapp className="mr-2 font-size-h4" />
                            WhatsApp
                        </button>
                        <button
                            className="btn btn-outline-secondary bg-primary-o-20 text-primary border-primary btn-sm"
                            onClick={handleCopy}
                        >
                            <IoLinkOutline className="mr-2 font-size-h5" />
                            Copy link
                        </button>
                    </div>
                    <div>
                        <button
                            className={`btn btn-sm px-5 btn-primary`}
                            onClick={handleEmailSend}
                        >
                            <IoMailOutline className="mr-2 font-size-h4" /> Email
                            </button>
                    </div>
                </div>
                {(!openShareSetting &&
                    (startDate || password)) && (
                        <div className="col-12 mt-5 mb-5">
                            <Alert variant={"warning"}>
                                <div className="text-warning font-weight-light">
                                    {startDate && password ? (
                                        `This Shared link is protected will only work with password & expires on ${moment(startDate).format('DD-MM-YYYY')}`
                                    ) : password ? (
                                        "This Shared link is protected will only work with password"
                                    ) : startDate ? (
                                        `This Shared link expires on ${moment(startDate).format('DD-MM-YYYY')}`
                                    ) : null}
                                </div>
                            </Alert>
                        </div>
                )}
                <div className="col-12 d-flex flex-column">
                    {successMsg && (
                        <div className={`success-container ${successMsg ? "show" : ""} mb-3`}>
                            <div className="success-bar">
                                ✅ {successMsg}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {openEditor && (
                <RichTextModal
                    open={openEditor}
                    setEditorValue={setEditorValue}
                    editorValue={editorValue}
                    setPhone={setPhone}
                    onClose={() => {setOpenEditor(false);setContactInput('')}}
                    initialValue={editorData}
                    title="Diamond Details"
                    setSuccessMsg={setSuccessMsg}
                    handleWhatsAppShare={handleWhatsAppShare}
                    onCopy={async (content) => {
                        const blob = new Blob([content], { type: "text/html" });
                        const data = [new ClipboardItem({ "text/html": blob })];

                        await navigator.clipboard.write(data);
                        setSuccessMsg('Text copied to clipboard!')
                        setOpenEditor(false);
                    }}
                />
            )}
        </>
    );
};

export default SharingComponent;
